var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',[_c('div',{staticClass:"p-4 d-flex align-items-center"},[_c('Row',{staticClass:"toggle-row mr-3",attrs:{"rounded":""}}),_c('Row',{staticClass:"w-75",attrs:{"rounded":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }